/**
 * 🆕 [v9 — 2026-06-12] Découpage d'une liste `dates_chantier` en runs
 * calendaires strictement consécutifs.
 *
 * CONTEXTE — Bug #1 P0 Calendrier de production (signalé par Eliot) :
 *   Le rendu Gantt utilisait jusque-là un fallback qui créait UN seul segment
 *   couvrant `[dates_chantier[0], dates_chantier[last]]`. Conséquence : pour
 *   un BT avec dates `[1,2,3,4,5,8,9,11,16]` juin, la barre traversait
 *   visuellement tous les jours intermédiaires (10, 12-15) même s'ils
 *   n'étaient pas sélectionnés. Faussait la planification.
 *
 * RÈGLE — 2 dates appartiennent au même run si et seulement si leur écart
 * calendaire est de 1 jour exactement. Conséquence directe :
 *   - Un weekend non sélectionné (sam/dim) CASSE le run (vendredi → lundi = 3j)
 *   - Un jour de semaine non sélectionné CASSE le run (mar → jeu = 2j)
 *   - 1 date isolée = 1 run d'1 élément
 *
 * Cette règle est différente de `detectSegments` dans `CalendrierProduction.jsx`
 * (qui utilise `> 3` pour la SÉMANTIQUE de déplacement de chantier). Ici on
 * vise le RENDU VISUEL : les jours non couverts doivent rester des trous.
 *
 * @param {string[]} dates  Liste de dates ISO `'YYYY-MM-DD'` (peut être non triée, peut avoir des doublons)
 * @returns {Array<{ firstDate: string, lastDate: string, dates: string[] }>}
 *
 * @example
 *   computeBTRuns(['2026-06-01','2026-06-02','2026-06-03','2026-06-04','2026-06-05','2026-06-08','2026-06-09','2026-06-11','2026-06-16'])
 *   // → [
 *   //   { firstDate:'2026-06-01', lastDate:'2026-06-05', dates:['2026-06-01'...'2026-06-05'] },
 *   //   { firstDate:'2026-06-08', lastDate:'2026-06-09', dates:[...] },
 *   //   { firstDate:'2026-06-11', lastDate:'2026-06-11', dates:[...] },
 *   //   { firstDate:'2026-06-16', lastDate:'2026-06-16', dates:[...] },
 *   // ]
 */
export function computeBTRuns(dates) {
  if (!dates || dates.length === 0) return [];
  // Dédoublonner + trier ascendant
  const sorted = [...new Set(dates)].sort();
  const runs = [];
  let cur = [sorted[0]];
  const dayMs = 24 * 60 * 60 * 1000;

  for (let i = 1; i < sorted.length; i++) {
    const prev = new Date(sorted[i - 1] + 'T12:00:00');
    const curr = new Date(sorted[i] + 'T12:00:00');
    const diff = Math.round((curr - prev) / dayMs);
    if (diff === 1) {
      cur.push(sorted[i]);
    } else {
      runs.push(cur);
      cur = [sorted[i]];
    }
  }
  runs.push(cur);

  return runs.map(r => ({
    firstDate: r[0],
    lastDate: r[r.length - 1],
    dates: r,
  }));
}
